export { DMS_MODULE } from '../constants';
export const NAME = 'ZakaznikProdejce';
export const CRUMB_LABEL_KEY = 'edtZakaznikprod';
